var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50.31%",
    x2: "50%",
    y1: "74.74%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE98A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "67.7%",
    stopColor: "#B63E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#68126F"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 603,
    cy: 682,
    r: 93
  }), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "203.2%",
    height: "203.2%",
    x: "-51.6%",
    y: "-51.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "49.48%",
    x2: "49.87%",
    y1: "11.66%",
    y2: "77.75%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7EAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5765E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "91.59%",
    x2: "66.97%",
    y1: "5.89%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A22A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EE7566"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "49.48%",
    x2: "49.61%",
    y1: "11.66%",
    y2: "98.34%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7EAB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E5765E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "78.5%",
    x2: "36.4%",
    y1: "106.76%",
    y2: "26.41%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A22A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EE7566"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    filter: "url(#b)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF6CB",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    opacity: 0.3,
    transform: "translate(14 23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 203,
    cy: 255,
    r: 3,
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 234,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 264,
    r: 2,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113,
    cy: 65,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202,
    cy: 2,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 114,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 144,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 224,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 453,
    cy: 65,
    r: 3,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 513,
    cy: 255,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593,
    cy: 115,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 803,
    cy: 5,
    r: 3,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502,
    cy: 134,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 832,
    cy: 204,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 752,
    cy: 114,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 933,
    cy: 255,
    r: 3,
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 703,
    cy: 225,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 903,
    cy: 55,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 982,
    cy: 144,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 632,
    cy: 14,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 550)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8E2C15",
    d: "M259 5.47c0 5.33 3.33 9.5 10 12.5s9.67 9.16 9 18.5h1c.67-6.31 1-11.8 1-16.47 8.67 0 13.33-1.33 14-4 .67 4.98 1.67 8.3 3 9.97 1.33 1.66 2 5.16 2 10.5h1c0-5.65.33-9.64 1-11.97 1-3.5 4-10.03-1-14.53S295 7 290 3c-5-4-10-3-13 2s-5 7-9 7-5-3.53-5-5.53c0-2 2-5-1.5-5s-7.5 0-7.5 2c0 1.33 1.67 2 5 2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1024 390H0V105.08C77.3 71.4 155.26 35 297.4 35c250 0 250.76 125.25 500 125 84.03-.08 160.02-18.2 226.6-40.93V390z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M1024 442H0V271.82c137.51-15.4 203.1-50.49 356.67-60.1C555.24 199.3 606.71 86.59 856.74 86.59c72.78 0 124.44 10.62 167.26 25.68V442z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1024 112.21V412H856.91c99.31-86.5 112.63-140.75 39.97-162.78C710.24 192.64 795.12 86.58 856.9 86.58c72.7 0 124.3 10.6 167.09 25.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M1024 285.32V412H857c99.31-86.6 112.63-140.94 39.97-163L1024 285.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M0 474V223.93C67.12 190.69 129.55 155 263 155c250 0 331.46 162.6 530 175 107.42 6.71 163-26.77 231-58.92V474H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M353.02 474H0V223.93C67.12 190.69 129.55 155 263 155c71.14 0 151.5 12.76 151.5 70.5 0 54.5-45.5 79.72-112.5 109-82.26 35.95-54.57 111.68 51.02 139.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M353.02 474H0v-14.8l302-124.7c-82.26 35.95-54.57 111.68 51.02 139.5z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    opacity: 0.2,
    transform: "translate(288 523)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 110,
    r: 110
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 78,
    r: 60
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 220,
    r: 70
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.08,
    transform: "translate(135 316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 80.22a14.2 14.2 0 0 1 20 0 14.2 14.2 0 0 0 20 0l20-19.86a42.58 42.58 0 0 1 60 0l15 14.9a21.3 21.3 0 0 0 30 0 21.3 21.3 0 0 1 30 0l.9.9A47.69 47.69 0 0 1 220 110H0v-5.76c0-9.02 3.6-17.67 10-24.02zm559.1-66.11l5.9-5.86c11.07-11 28.93-11 40 0l10 9.94a14.19 14.19 0 0 0 20 0 14.19 14.19 0 0 1 20 0 16.36 16.36 0 0 0 21.3 1.5l8.7-6.47a33.47 33.47 0 0 1 40 0l4.06 3.03A39.6 39.6 0 0 1 755 48H555a47.77 47.77 0 0 1 14.1-33.89z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.5f779885af2a6e420bfb24103fb983e7.svg";
export { ForwardRef as ReactComponent };